module.exports = __webpack_public_path__ + "img/shuangzita.3ca5052.png";